import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TranscationDetailKeyKownService {
    // Array to store the order of columns, excluding non-focusable columns
    columnOrder: string[] = [];

    // Update the order of columns to exclude non-focusable columns
    updateColumnOrder(visibleColumns: any[]): void {
        // Set the column order based on the visible columns, mapping to column names
        this.columnOrder = visibleColumns.map(col => col.name);
        
        // Define the list of non-focusable columns to exclude
        const nonFocusableColumns = ['fDesc', 'discountAmount', 'amount', 'taxAmount', 'netAmount','accountName',
            'debitLocal',
            'creditLocal',
            'wTaxAmount'];
        
        // Filter out non-focusable columns from the columnOrder array
        this.columnOrder = this.columnOrder.filter(col => !nonFocusableColumns.includes(col));
    }

    // Get the adjacent column name based on the current column and direction
    getAdjacentColumn(currentColumn: string, direction: number): string {
        // Find the index of the current column in the columnOrder array
        const currentIndex = this.columnOrder.indexOf(currentColumn);
        
        // Calculate the index of the adjacent column, wrapping around the array
        let nextIndex = (currentIndex + direction + this.columnOrder.length) % this.columnOrder.length;
        
        // Return the name of the adjacent column
        return this.columnOrder[nextIndex];
    }

    // Find the cell element based on the row index and column name
    findCell(editableCells: any[], rowIndex: number, columnName: string): any {
        // Search for the cell that matches the given row index and column name
        return editableCells.find(cell =>
            cell.nativeElement.getAttribute('data-column') === columnName &&
            parseInt(cell.nativeElement.getAttribute('data-row'), 10) === rowIndex
        );
    }

    // Focus the next cell based on the row index and column name
    focusNextCell(editableCells: any[], rowIndex: number, columnName: string): void {
        // Find the cell element for the given row index and column name
        const nextCell = this.findCell(editableCells, rowIndex, columnName);
        
        // If the cell is found, focus on the first focusable element within it
        if (nextCell) {
            const focusableElement = nextCell.nativeElement.querySelector('input, select, [contenteditable]');
            if (focusableElement) {
                focusableElement.focus();
            }
        }
    }

    // Focus the next element based on the current index, column, and visible columns
    focusNextElement(currentIndex: number, currentColumn: string, visibleColumns: any[], editableCells: any[]): void {
        // Update the column order to reflect the current visible columns
        this.updateColumnOrder(visibleColumns);
        
        // Get the index of the next column in the column order
        const nextColumnIndex = this.columnOrder.indexOf(currentColumn) + 1;
        
        // Determine the next column and the next row index
        const nextColumn = this.columnOrder[nextColumnIndex] || this.columnOrder[0];
        const nextRowIndex = nextColumnIndex >= this.columnOrder.length ? currentIndex + 1 : currentIndex;

        // Schedule the focus operation for the next element
        setTimeout(() => {
            this.focusElement(editableCells, nextRowIndex, nextColumn);
        });
    }

    // Focus an element based on the given row and column names
    focusElement(editableCells: any[], rowIndex: number, columnName: string): void {
        // Find the cell element for the given row index and column name
        const nextCell = this.findCell(editableCells, rowIndex, columnName);
        
        // If the cell is found, focus on the first focusable element within it
        if (nextCell) {
            const focusableElement = nextCell.nativeElement.querySelector('input, select, [contenteditable]');
            if (focusableElement) {
                focusableElement.focus();
            }
        }
    }

    // Check if the next row index is within the valid range of item details
    isRowIndexValid(rowIndex: number, itemDetailsLength: number): boolean {
        // Return true if the row index is within the bounds of the item details length
        return rowIndex >= 0 && rowIndex < itemDetailsLength;
    }
}